import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { DPassLogo } from './DPassLogo';

interface State { hasError: boolean; error: Error | null; }

class ErrorBoundaryBase extends React.Component<WithTranslation & { children: React.ReactNode }, State> {
  constructor(props: WithTranslation & { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('ErrorBoundary:', error, info);
  }

  render() {
    const { t } = this.props;
    if (this.state.hasError) {
      return (
        <div className="min-h-screen sidebar-gradient flex flex-col items-center justify-center gap-4 text-center px-4">
          <DPassLogo className="w-14 h-14" />
          <h1 className="text-2xl font-bold text-white">{t('errors.somethingWentWrong')}</h1>
          <p className="text-slate-400 max-w-md">
            {this.state.error?.message || t('errors.unexpectedError')}
          </p>
          <button onClick={() => window.location.reload()} className="btn-primary mt-2">
            {t('errors.reload')}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export const ErrorBoundary = withTranslation()(ErrorBoundaryBase);
